import logoBlue from '@/images/collectia-blue.svg'
import logoWhite from '@/images/collectia-white.svg'
import { cn } from '@/lib/utils'

/**
 * Collectia wordmark. Use the white variant on Collectia Blue / dark surfaces,
 * the blue variant on light/off-white surfaces (DESIGN_GUIDELINES §4).
 *
 * White-label note: these default assets are bundled for the scaffold. Per
 * partner, the active logo URLs come from branding shared props and this
 * component will prefer those when present.
 */
export function Logo({
  variant = 'blue',
  src,
  className,
  alt = 'Collectia',
}: {
  variant?: 'blue' | 'white'
  src?: string
  className?: string
  alt?: string
}) {
  const resolved = src ?? (variant === 'white' ? logoWhite : logoBlue)
  return <img src={resolved} alt={alt} className={cn('h-7 w-auto', className)} />
}
